import styled from 'styled-components';

export const StyledDesignThemes = styled.div`
  flex: 1;
  background-color: #fff;
  .theme-search-create-wrapper {
    display: flex;
    justify-content: space-between;
  }
`;
